import React from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import {
    hideMessage,
    showAuthLoader,
    hideAuthLoader,
    userFacebookSignIn,
    userGithubSignIn,
    userGoogleSignIn,
    userSignIn,
    userRequestSignInCode,
    userSignInPasswordless,
    userTwitterSignIn,
} from 'actions/Auth';
import CircularProgress from 'components/CircularProgress';
import { isAuthenticated } from 'services/Authentication';
import SimpleModal from 'components/simpleModal';
import ErrorBoundary from 'components/errorBoundary';

class SignIn extends React.Component {
    constructor() {
        super();
        // username: 'cpsolutions28@gmail.com emptest@emptest.com.au orgtest@orgtest.com.au', - testtest
        this.state = {
            username: '',
            password: '',
            code: '',
        };
    }

    componentDidMount() {
        this.props.hideAuthLoader();
    }

    componentDidUpdate() {
        if (this.props.showMessage) {
            setTimeout(() => {
                this.props.hideMessage();
            }, 100);
        }
        if (isAuthenticated()) {
            this.props.history.push('/');
        }
    }

    getModalBody() {
        let modalBodyText = '';
        modalBodyText += 'Step 1 - Enter your username and a code will be sent to your nominated email address.<br/>';
        modalBodyText += 'Check your email for the code (please check your spam folder as well if it is not found).<br/>';
        modalBodyText += 'Step 2 - Enter the code sent to your email.<br/>';
        modalBodyText += 'If for any reason the email with the was not received - please use the resend code option.<br/>';
        return modalBodyText;
    }

    render() {
        const { username, code, password } = this.state;
        const { showMessage, loader, alertMessage, authUserCode } = this.props;
        return (
            <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                <div className="app-login-main-content">
                    <div className="app-logo-content d-flex align-items-center justify-content-center">
                        <Link className="logo-lg" to="/">
                            <img src="assets/images/sea.jpg" height="150" width="177" />
                        </Link>
                    </div>

                    <div className="app-login-content">
                        <div className="text-center">
                            <div className="d-flex justify-content-between">
                                <h1>
                                    <IntlMessages id="appModule.signIn" />
                                </h1>
                                <span>
                                    <SimpleModal modalTitle="Sign in instructions" buttonText="Help" modalBody={this.getModalBody()} actionClassName="icon" />
                                </span>
                            </div>
                        </div>
                        {/* <div className=" d-flex align-items-center">
                            <i className={'detail-icon text-blue-grey'}/>
                            <span><h2><IntlMessages id="appModule.signIn" /></h2></span>
                            <span className="badge badge-primary ml-auto"><SimpleModal modalTitle='Signin instructions' buttonText='Help' modalBody={this.getModalBody()} /></span>
                        </div> */}
                        <div className="app-login-form">
                            <form>
                                <div className="form-group mb-3">
                                    <input
                                        id="loginInput"
                                        placeholder="Username"
                                        onChange={(event) => this.setState({ username: event.target.value })}
                                        defaultValue={username}
                                        className="form-control form-control-lg"
                                    />
                                </div>

                                <div className="form-group mb-3">
                                    <input
                                        id="pwInput"
                                        type="password"
                                        placeholder="Password"
                                        onChange={(event) => this.setState({ password: event.target.value })}
                                        defaultValue={password}
                                        className="form-control form-control-lg"
                                    />
                                </div>

                                <div className="mb-3 d-flex align-items-center justify-content-between">
                                    <Button
                                        id="loginBtn" 
                                        onClick={() => {
                                            this.props.showAuthLoader();
                                            this.props.userSignIn({ username, password });
                                        }}
                                        color="primary"
                                        className="text-uppercase"
                                    >
                                        <IntlMessages id="appModule.signIn" />
                                    </Button>
                                </div>

                                <div className="mb-3 d-flex align-items-center justify-content-between">
                                    <Button
                                        onClick={() => {
                                            this.props.showAuthLoader();
                                            this.props.userRequestSignInCode({ username });
                                        }}
                                        color="primary"
                                        className="text-uppercase"
                                    >
                                        {authUserCode ? <IntlMessages id="appModule.resendCode" /> : <IntlMessages id="appModule.requestCode" />}
                                    </Button>

                                    {/* <Link to="/signup">
                                        <IntlMessages id="signIn.signUp" />
                                    </Link> */}
                                </div>
                                {authUserCode ? (
                                    <React.Fragment>
                                        <div className="description">
                                            <p className="timeline-tile text-red">
                                                <IntlMessages id="appModule.signinInstructions" />
                                            </p>
                                        </div>
                                        <div className="form-group mb-3">
                                            <input
                                                placeholder="Code"
                                                onChange={(event) => this.setState({ code: event.target.value })}
                                                defaultValue={code}
                                                className="form-control form-control-lg"
                                            />
                                        </div>

                                        <div className="mb-3 d-flex align-items-center justify-content-between">
                                            <Button
                                                onClick={() => {
                                                    this.props.showAuthLoader();
                                                    this.props.userSignInPasswordless({ username, code });
                                                }}
                                                color="primary"
                                                className="text-uppercase"
                                            >
                                                <IntlMessages id="appModule.enterCode" />
                                            </Button>
                                        </div>
                                    </React.Fragment>
                                ) : null}
                            </form>
                        </div>
                    </div>
                </div>
                {loader && (
                    <div className="loader-view">
                        <CircularProgress />
                    </div>
                )}
                {showMessage && NotificationManager.error(alertMessage || '')}
                <ErrorBoundary>
                    <NotificationContainer />
                </ErrorBoundary>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }) => {
    const { loader, alertMessage, showMessage, authUser, authUserCode } = auth;
    return { loader, alertMessage, showMessage, authUser, authUserCode };
};

export default connect(mapStateToProps, {
    userSignIn,
    userSignInPasswordless,
    userRequestSignInCode,
    showAuthLoader,
    hideAuthLoader,
    hideMessage,
    userFacebookSignIn,
    userGoogleSignIn,
    userGithubSignIn,
    userTwitterSignIn,
})(SignIn);



// WEBPACK FOOTER //
// ./containers/SignIn.js